import { createContext, useContext } from 'react';
import type { BrandingConfig } from './BrandingContext';

interface BrandingContextValue {
  branding: BrandingConfig;
  setBranding: (branding: BrandingConfig) => void;
}

export const BrandingContext = createContext<BrandingContextValue>({
  branding: {
    platformName: 'PracticeNova',
    primaryColor: '#4CAF50',
    secondaryColor: '#2196F3',
  },
  setBranding: () => {},
});

export function useBrandingContext() {
  return useContext(BrandingContext);
}
